import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ToastProvider } from "./contexts/ToastContext";
import CommandPalette from "./components/feature/CommandPalette";
import ConciergeWidget from "./components/feature/ConciergeWidget";


function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <I18nextProvider i18n={i18n}>
            <BrowserRouter basename={__BASE_PATH__}>
              <CommandPalette />
              <AppRoutes />
              <ConciergeWidget />
            </BrowserRouter>
          </I18nextProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;